var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 33.5714L30.9965 23.5L18.8 13.4286V33.5714ZM45.966 7.285C46.2715 8.86286 46.483 10.9779 46.624 13.6636C46.7885 16.3493 46.859 18.6657 46.859 20.68L47 23.5C47 30.8521 46.624 36.2571 45.966 39.715C45.3785 42.7364 44.0155 44.6836 41.9005 45.5229C40.796 45.9593 38.775 46.2614 35.673 46.4629C32.618 46.6979 29.8215 46.7986 27.2365 46.7986L23.5 47C13.6535 47 7.52 46.4629 5.0995 45.5229C2.9845 44.6836 1.6215 42.7364 1.034 39.715C0.7285 38.1371 0.517 36.0221 0.376 33.3364C0.2115 30.6507 0.141 28.3343 0.141 26.32L0 23.5C0 16.1479 0.376 10.7429 1.034 7.285C1.6215 4.26357 2.9845 2.31643 5.0995 1.47714C6.204 1.04071 8.225 0.738571 11.327 0.537142C14.382 0.302142 17.1785 0.201428 19.7635 0.201428L23.5 0C33.3465 0 39.48 0.537143 41.9005 1.47714C44.0155 2.31643 45.3785 4.26357 45.966 7.285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.d6bafebdca4b0de1446cf5cd5d73c0e9.svg";
export { ForwardRef as ReactComponent };